/** Extrait le canal de paiement depuis la payload KKiaPay (widget / webhook). */
export function extractKkiapayChannel(payload) {
  if (!payload || typeof payload !== 'object') return null;
  const candidates = [
    payload.method,
    payload.paymentMethod,
    payload.payment_method,
    payload.paymentmethod,
    payload.operator,
    payload.source,
    payload.network,
    payload?.stateData?.method,
    payload?.stateData?.paymentMethod,
  ];
  for (const candidate of candidates) {
    if (candidate != null && String(candidate).trim()) {
      return String(candidate).trim();
    }
  }
  return null;
}

/** Extrait le compte / téléphone depuis la payload KKiaPay. */
export function extractKkiapayAccount(payload) {
  if (!payload || typeof payload !== 'object') return null;
  const candidates = [
    payload.account,
    payload.phone,
    payload.msisdn,
    payload?.stateData?.account,
  ];
  for (const candidate of candidates) {
    if (candidate != null && String(candidate).trim()) {
      return String(candidate).trim();
    }
  }
  return null;
}
